// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"LoadingSpinner_loadingSpinner__t+mRF","rotation":"LoadingSpinner_rotation__MV17l"};